module.exports = __webpack_public_path__ + "img/collaborate_10.dcddbfe0.jpg";